<template>
  <div class="mt-4" align="justify">
    <div v-if="serviceFailure">
      <b-alert show variant="danger">{{ message }}</b-alert>
    </div>
    <div v-else>
      <div class="text-center text-primary my-2" v-if="isBusy">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Loading...</strong>
      </div>

      <div v-else>
        <!-- Header Section-->
        <div>
          <h1>ARRA Impact in {{ reports.name }}</h1>
        </div>
        <!-- Public Health Burden-->
        <div>
          <h2>Public Health Burden</h2>
          <div class="sub-section, text-align:justify">
            {{ reports.publicHealthBurden.overview
            }}<a
              href @click.prevent="scrollToFooter()" 
              class="sup"
              v-if="reports.publicHealthBurden.footerIds"
            >
              <sup>{{ reports.publicHealthBurden.footerIds }}</sup>
            </a>
            <ul>
              <li
                v-for="(bullet, subSecInd) in reports.publicHealthBurden
                  .sections"
                :key="'pub' + subSecInd"
              >
                <strong>{{ bullet.sectionHeading }}</strong>
                <template v-if="bullet.text">- {{ bullet.text }}</template>
                <a href @click.prevent="scrollToFooter"  class="sup">
                  <sup>{{ bullet.footerIds }}</sup>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <br />

        <!-- Section with Sub sectio and orderedlist data-->
        <div v-for="(section, secInd) in reports.sections" :key="secInd">
          <h2>
            {{ section.sectionName
            }}<a
              href @click.prevent="scrollToFooter" 
              class="sup"
              v-if="section.sectionNameFooterIds"
            >
              <sup>{{ section.sectionNameFooterIds }}</sup>
            </a>
          </h2>
          <div class="sub-section, text-align:justify">
            {{ section.overview }}
            <a href @click.prevent="scrollToFooter"  class="sup" v-if="section.footerIds">
              <sup>{{ section.footerIds }}</sup>
            </a>
          </div>
          <div class="sub-section-bullet">
            <ul>
              <li
                v-for="(bullet, subSecInd) in section.subSections"
                :key="subSecInd"
              >zssss 
                <strong>{{ bullet.sectionHeading }}</strong>
                <template v-if="bullet.text"
                  >- <span v-html="bullet.text" v-linkify> </span
                ></template>
                <a href @click.prevent="scrollToFooter" class="sup">
                  <sup> {{ bullet.footerIds }}</sup>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <br />
        <div id="ICs">
          <h2>Contributing NIH Institutes & Centers</h2>
          <ul>
            <li v-for="(ICs, icId) in reports.icList" :key="icId">
              {{ ICs.icName }} ({{ ICs.icCode }})
            </li>
          </ul>
        </div>
        <hr />

        <!-- footer section-->
        <div id="ftr">
          <a name="footerloc"></a>
          <ol>
            <li
              v-for="(fldFooterNote, footerInd) in reports.footerData"
              :key="footerInd"
            >
              <!-- Display Project Number-->
              <template v-if="fldFooterNote.projNum.length > 0">
                <div
                  v-for="(link, linkInd) in fldFooterNote.projNum"
                  :key="linkInd"
                >
                  <a :href="footerurl + link">{{ link }}</a>
                  - {{ fldFooterNote.footerText[linkInd] }}
                </div>
              </template>
              <!-- Display pubIds-->
              <div v-if="fldFooterNote.pubIds.length > 0">
                <template v-for="(link, linkInd) in fldFooterNote.pubIds"
                    :key="'pub' + linkInd">
                  <a
                    :href="`http://www.ncbi.nlm.nih.gov/pubmed/${link}`"
                    >http://www.ncbi.nlm.nih.gov/pubmed/{{ link }}</a
                  ><template v-if="linkInd < fldFooterNote.pubIds.length - 1"
                    >,</template
                  >
                </template>
              </div>
              <!-- Display Only footer text -->
              <div v-if="fldFooterNote.projNum.length < 1">
                <template v-for="(link, linkInd) in fldFooterNote.footerText" :key="'data' + linkInd">
                  <span v-html="link"></span>
                </template>
              </div>
            </li>
          </ol>
        </div>
      </div>
    </div>

    <div class="my-4">
      <b-button variant="outline-primary" :href="`?reportName=impact`"
        >Go Back To Impact Reports</b-button
      >
    </div>
  </div>
</template>
<script>
import { data } from '@/shared';
import { SERVICE_UNAVAILABLE_ERROR_MSG } from '@/shared/config.js';

export default {
  name: 'ImpactReportDetails',
  data() {
    return {
      reports: [],
      isBusy: false,
      message: SERVICE_UNAVAILABLE_ERROR_MSG,
      serviceFailure: false,
    };
  },
  props: {
    footerurl: String,
    id: Number,
  },
  async created() {
    if (this.id) {
      await this.getImpactReportDetailsData();
    }
  },
  methods: {
    async getImpactReportDetailsData() {
      this.reports = [];
      this.isBusy = true;

      this.reports = await data.getImpactReportById(this.id);

      if (this.reports instanceof Error) {
        this.serviceFailure = true;
      }
      this.isBusy = false;
    },
    scrollToFooter () {
      let pos = $('#ftr')[0].getBoundingClientRect().top;

      window.scrollTo({
        top: window.scrollY + pos - 25
      });
    }
  },
};
</script>
<style></style>
